// src/components/ui/LoadingOverlay/styles.ts
import styled from "styled-components";

export const Overlay = styled.div<{ $shown: boolean }>`
  position: fixed;
  inset: 0;
  z-index: 1400;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(16, 32, 27, 0.25);
  backdrop-filter: blur(1.5px);
  opacity: ${(p) => (p.$shown ? 1 : 0)};
  transition: ${(p) => p.theme.tokens.transition.fade};
`;

export const Card = styled.div<{ $shown: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  background: ${(p) => p.theme.tokens.colors.surface};
  border-radius: ${(p) => p.theme.tokens.radii.lg}px;
  padding: 22px 26px;
  box-shadow: ${(p) => p.theme.tokens.shadows.modal};
  transform: ${(p) => (p.$shown ? "scale(1)" : "scale(0.94)")};
  transition: transform 0.3s ${(p) => p.theme.tokens.transition.spring},
    ${(p) => p.theme.tokens.transition.fade};
`;

export const Label = styled.div`
  font-family: ${(p) => p.theme.tokens.font.family};
  font-weight: 800;
  font-size: 14.5px;
  color: ${(p) => p.theme.tokens.colors.muted};
`;
